import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="decorative-footer">
      <div className="footer-pattern"></div>
      <div className="footer-text">Galileo's Library Project</div>
    </div>
  );
}

export default Footer;